import React from 'react';
import PropTypes from 'prop-types';
import { HelpBlock } from 'react-bootstrap';

function FormErrors({
  errors,
  component: ErrorComponent = HelpBlock,
  showErrors = true
}) {
  if (!showErrors) {
    return null;
  }
  return (
    <div className="form-errors">
      {errors.map((error, index) => (
        <ErrorComponent key={index}>{error}</ErrorComponent>
      ))}
    </div>
  );
}

FormErrors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  component: PropTypes.element,
  showErrors: PropTypes.boolean
};

export default FormErrors;



// WEBPACK FOOTER //
// ./src/components/FormErrors/index.js